import * as React from 'react';
import { CheckmarkIcon } from '../../../../components/Icons/newIcons/CheckmarkIcon';
import { getCurrencyString } from '../../../../components/PriceString';
import { config } from '../../../../config';
import { eventTracker } from '../../../../helpers/EventTracker/EventTracker';
import { __ } from '../../../../helpers/TranslationService';
import { IPackageCruise } from '../../../../interfaces';
import * as S from './styled';
import * as InclusivesIcons from '../../helper/InclusiveIcons';
import { Button } from '../../../../components/Button/Button';
import { packageCruiseEnabled } from '../../../../helpers/packageCruise';
import useWindowSize from '../../../../hooks/useViewport';
import { isDesktop } from '../../../../helpers/responsiveHelpers/responsiveHelpers';
import { ArrowRightIcon } from '../../../../components/Icons/ArrowRightIcon';
interface IDreamLinesPackageBanner {
    currency: string;
    withMessage: boolean;
    onlyMobile?: boolean;
    packageCruise: IPackageCruise;
    countryCode: string;
}

const sendEventTrak = (url: string) => {
    eventTracker.track({
        category: 'banner',
        action: 'banner-package-top',
        label: '',
    });
    window.location.href = url;
};

const DreamLinesPackageBanner = (props: IDreamLinesPackageBanner) => {
    const { packageCruise, currency, withMessage } = props;
    const onlyMobile = props.onlyMobile || false;

    if (!packageCruiseEnabled(props.countryCode)) {
        return null;
    }

    const packageLogo = {
        de: `${config.images}/common/DLPackage.svg`,
        c1uk: `${config.images}/common/C1stPackage.svg`,
        c1au: `${config.images}/common/C1stPackage.svg`,
    }[props.countryCode];

    const packageCruiseIcons = packageCruise.icons.filter((icon) => icon?.text && icon?.icon);

    const { width } = useWindowSize();
    const [isDesktopView, setIsDesktopView] = React.useState(isDesktop(width));

    React.useEffect(() => {
        setIsDesktopView(isDesktop(width));
    }, [width]);

    return (
        <S.DreamLinesPackageLink
            id="dreamLinesBannerTop"
            onClick={() => sendEventTrak(packageCruise.url)}
            className={onlyMobile ? 'onlyMobileVisible' : ''}
        >
            <S.DreamLinesPackageBanner>
                <S.LogoContainer>
                    <img src={packageLogo} alt="Package Logo" />
                    <div id="plus-icon">+</div>
                </S.LogoContainer>
                <S.InfoContainer>
                    <div id="info-contianer__inner">
                        {withMessage && (
                            <p id="disclaimer">
                                {/* Some new translation key to add whit the price diff */}
                            </p>
                        )}
                        <div id="included-services">
                            {packageCruiseIcons.map((icon) => {
                                const IconComp = InclusivesIcons[icon.icon];
                                if (!IconComp) {
                                    return null;
                                }
                                return (
                                    <div key={`icon-${icon.text}`} className="included">
                                        <IconComp width={25} height={25} />
                                        <span>{__(icon.text, 'dreamlines')}</span>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                    <div id="go-to-package">
                        {isDesktopView ? (
                            <Button withArrow color={'tertiary'} size={'medium'}>
                                {`${__('pricePrefix', 'dreamlines')} `}
                                <b>{getCurrencyString(packageCruise.minPrice, currency)} </b>
                                {`${__('request.pP', 'dreamlines')} `}
                            </Button>
                        ) : (
                            <S.MobilePrice>
                                {`${__('pricePrefix', 'dreamlines')} `}
                                <b>{getCurrencyString(packageCruise.minPrice, currency)} </b>
                                {`${__('request.pP', 'dreamlines')} `}
                                <ArrowRightIcon width={12} height={12} />
                            </S.MobilePrice>
                        )}
                    </div>
                </S.InfoContainer>
            </S.DreamLinesPackageBanner>
            <S.MobileIncludedServices>
                {packageCruiseIcons.map((icon) => {
                    return (
                        <div key={`icon-${icon.text}`} className="included-mobile">
                            <CheckmarkIcon width="12" height="12" />
                            <span>{__(icon.text, 'dreamlines')}</span>
                        </div>
                    );
                })}
            </S.MobileIncludedServices>
        </S.DreamLinesPackageLink>
    );
};
export default DreamLinesPackageBanner;
